function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { crudDP } from '@/mixins/crud.js';
import InitialSetupService from '@/apps/data-platform/services/tables_views/initial_setup_service';
import { envConfig } from '@/js/constants';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import tasks from '@/js/tasks';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
export default {
  name: 'InitialSetupPage',
  components: {
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  mixins: [crudDP],
  data: function data() {
    return {
      userProfile: '',
      areaDescription: '',
      tables: [],
      fields: [{
        value: 'source',
        text: 'Source',
        sortable: true,
        class: 'text-left'
      }, {
        value: 'tableReference.tableId',
        text: 'Table',
        sortable: true,
        class: 'text-left'
      }, {
        value: 'tableReference.datasetId',
        text: 'Dataset',
        sortable: true,
        class: 'text-left'
      }, {
        value: 'tableReference.projectId',
        text: 'Project',
        sortable: true,
        class: 'text-left'
      }, {
        value: 'date_end',
        text: 'Until',
        sortable: true,
        align: 'center'
      }],
      filter: '',
      //isButtonHidden: false,
      checkAll: false,
      tablesSelected: [],
      pagination: {
        current: 1,
        limit: 10,
        total: 0,
        offset: 0
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['initial_setup_records'])), {}, {
    isButtonHidden: function isButtonHidden() {
      return this.tablesSelected.length > 0 ? true : false;
    }
  }),
  created: function created() {},
  watch: {
    initial_setup_records: function initial_setup_records(newVal) {
      if (newVal && newVal.length > 0) {
        this.getUserProfileByArea();
        this.tables = this.initial_setup_records[0]['tables'];
      }
    }
  },
  methods: {
    getUserProfileByArea: function getUserProfileByArea() {
      var _this = this;
      var area_id = this.initial_setup_records[0]['area_id'];
      var userprofile_id = this.initial_setup_records[0]['userprofile_id'];
      var data = {
        area_id: area_id,
        userprofile_id: userprofile_id
      };
      UserProfileService.getUserProfileByArea(data).then(function (response) {
        response.data.forEach(function (profile) {
          if (profile.userprofile_id == userprofile_id) _this.userProfile = profile.userprofile_description;
          _this.areaDescription = profile.area_description;
        });
        console.log(_this.userProfile, _this.areaDescription);
      }, function (err) {
        console.log(err);
      });
    },
    getRecords: function getRecords() {
      var _this2 = this;
      if (!this.tables.length) {
        this.toggleBusy();
        this.$store.dispatch('data-platform/getInitialSetup').then(function () {
          _this2.toggleBusy();
        });
      }
    },
    onConfirmRequest: function onConfirmRequest() {
      if (!this.isButtonHidden) {
        return;
      }
      //this.processing = false
      //this.busy = true
      this.$refs['dialogConfirmation'].onOpen();
    },
    onConfirm: function onConfirm(model) {
      if (model) {
        this.sendRequestAccess();
        this.busy = false;
        this.$refs['dialogConfirmation'].onClose();
      } else {
        this.onCancelRequest();
      }
    },
    onCancelRequest: function onCancelRequest() {
      this.busy = false;
      this.$refs['dialogConfirmation'].onClose();
    },
    sendRequestAccess: function sendRequestAccess() {
      var _this3 = this;
      this.processing = true;
      var data = {
        tables: this.tablesSelected
      };
      this.busy2 = true;
      return InitialSetupService.putInitialSetup(data).then(function (response) {
        if (response.success) {
          tasks.toast.success('La solicitud se ha enviado correctamente.');
        }
        _this3.busy2 = false;
        _this3.processing = false;
        _this3.busy = false;
        if (_this3.tables.length === _this3.tablesSelected.length) {
          _this3.$store.dispatch('data-platform/hideInitialSetupMenu').then(function () {
            _this3.$router.push({
              path: envConfig.defaultPathRedirect
            });
          });
        } else {
          _this3.$store.dispatch('data-platform/getInitialSetup');
        }
        return true;
      }, function (err) {
        _this3.busy2 = false;
        _this3.processing = false;
        _this3.busy = false;
      });
    },
    onRowSelected: function onRowSelected(items) {
      this.tablesSelected = items;
      this.isButtonHidden = this.tablesSelected.length > 0;
    },
    selectAllRows: function selectAllRows() {
      this.checkAll = !this.checkAll;
      if (this.checkAll) {
        this.$refs.selectableTable.selectAllRows();
      } else {
        this.$refs.selectableTable.clearSelected();
      }
    },
    onToggleSelected: function onToggleSelected(element) {
      console.log(element.items, element.value);
      this.tablesSelected = element.value ? this.tables : [];
    }
  }
};